/**
 * This reducer is for storing interpreter data for scenarios that need to work on china environment.
 * If we store on feature reducer it might cause more trobule.
 */

import {
    CHINA_INTERPRETER_RESET,
    CHINA_INTERPRETER_SET_PACEPRO,
    CHINA_INTERPRETER_SET_PACEPROCREATE,
    CHINA_INTERPRETER_SET_POWERGUIDANCE,
    CHINA_INTERPRETER_SET_POWERGUIDANCE_ALGO_DATA
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    pacePro: null,
    paceProCreate: null,
    powerGuidance: null,
    powerGuidanceAlgorithmData: null
};

// selectors
export const selectChinaInterpreterState = (state) => {
    return state.chinaInterpreterReducer;
};

export const selectChinaInterpreterPacePro = (state) => {
    const chinaInterpreter = selectChinaInterpreterState(state);
    return chinaInterpreter.pacePro;
};

export const selectChinaInterpreterPaceProCreate = (state) => {
    const chinaInterpreter = selectChinaInterpreterState(state);
    return chinaInterpreter.paceProCreate;
};

export const selectChinaInterpreterPowerGuidance = (state) => {
    const chinaInterpreter = selectChinaInterpreterState(state);
    return chinaInterpreter.powerGuidance;
};

export const selectChinaInterpreterPowerGuidanceAlgorithmData = (state) => {
    const chinaInterpreter = selectChinaInterpreterState(state);
    return chinaInterpreter.powerGuidanceAlgorithmData;
};

// handlers
const chinaInterpreterSetPacePro = (state, action) => {
    return {
        ...state,
        pacePro: action.payload
    };
};

const chinaInterpreterSetPaceProCreate = (state, action) => {
    return {
        ...state,
        paceProCreate: action.payload
    };
};

const chinaInterpreterSetPowerGuidance = (state, action) => {
    return {
        ...state,
        powerGuidance: action.payload
    };
};

/// ref: src/reducers/powerGuidance/powerGuidance.js
/// setPowerGuidanceSummaryFromAlgorithmData
/// setPowerGuidanceSplitsFromAlgorithmData

const chinaInterpreterSetPowerGuidanceAlogorithmData = (state, action) => {
    const newData = {};
    newData.summary = state.powerGuidanceAlgorithmData?.summary || {};
    newData.splits = state.powerGuidanceAlgorithmData?.splits || [];

    newData.summary = {
        ...newData.summary,
        ...(action.payload?.summary || {})
    };

    newData.splits = [...(action.payload?.splits || [])];
    return {
        ...state,
        powerGuidanceAlgorithmData: newData
    };
};

const chinaInterpreterReset = () => {
    return structuredClone(INITIAL_STATE);
};

const handlers = {
    [CHINA_INTERPRETER_SET_PACEPRO]: chinaInterpreterSetPacePro,
    [CHINA_INTERPRETER_SET_PACEPROCREATE]: chinaInterpreterSetPaceProCreate,
    [CHINA_INTERPRETER_SET_POWERGUIDANCE]: chinaInterpreterSetPowerGuidance,
    [CHINA_INTERPRETER_SET_POWERGUIDANCE_ALGO_DATA]: chinaInterpreterSetPowerGuidanceAlogorithmData,
    [CHINA_INTERPRETER_RESET]: chinaInterpreterReset
};

export default function chinaInterpreterReducer(state = INITIAL_STATE, action) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    }
    return handler(state, action);
}
